import {Drawer} from 'antd';
import {useEffect, useRef} from 'react';

import {Locale} from '../../../../../provider/locale/locale';
import {useDrawerWidthHack} from '../../../../../util/antd/drawer-hook';
import * as pageStyles from '../review-list-page-content.scss';

import {ReviewsFilter} from './reviews-filter';
import {ReviewsFilterDrawerFooter} from './reviews-filter-drawer-footer';
import {useReviewsFilter} from './use-reviews-filter';

type PropsType = {
    isOpen: boolean;
    onClose: () => void;
};

export function ReviewsFilterDrawer(props: PropsType): JSX.Element {
    const {isOpen, onClose} = props;

    const drawerWidth: string = useDrawerWidthHack();
    const filterHook = useReviewsFilter({applyMode: 'deferred', onDrawerClose: onClose});
    const {handleDrawerOpen, handleDrawerClose} = filterHook;
    const wasOpenRef = useRef(false);

    useEffect(() => {
        if (isOpen && !wasOpenRef.current) {
            handleDrawerOpen();
        }

        wasOpenRef.current = isOpen;
    }, [handleDrawerOpen, isOpen]);

    return (
        <Drawer
            classNames={{body: pageStyles.Reviews_filterDrawerBody}}
            destroyOnClose
            footer={<ReviewsFilterDrawerFooter filterHook={filterHook} />}
            onClose={handleDrawerClose}
            open={isOpen}
            placement="right"
            title={<Locale stringKey="BUTTON__FILTER" />}
            width={drawerWidth}
        >
            <ReviewsFilter filterHook={filterHook} isDrawerContent />
        </Drawer>
    );
}
